import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppConfig } from "src/app/auth/helpers/app-config";

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  private userData: any;
  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {}

  fetchList(url: string, params: any): Observable<any> {
    return this.http.get<any>(this.config.api + url + '/', { params });
  }

  fetchDetail(url: string, params: any): Observable<any> {
    return this.http.get<any>(this.config.api + url + '/', { params });
  }
   setData(data: any) {
     localStorage.setItem('userData', JSON.stringify(data));
  }
  getData(){
    return localStorage.getItem('userData')
  }
  clear() {
    this.userData = null;
  }

  fetchUserInfo(): Observable<any> {
    return this.http.get(this.config.api + '/client/dashboard/');
  }

  fetchDataConsumption(data:any): Observable<any> {
    let params:HttpParams = new HttpParams()
      .set("frm",data['frm'])
      .set("to",data['to'])
      .set("period",data['period'])
    return this.http.get(this.config.api + '/client/customerconsumption/',{params:params});
  }
}
